export default "__VITE_ASSET__DGDKCJrW__"